import { getApiBaseUrl, fetchAPI } from "./baseApi";

export async function loginAdmin(username, password) {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}/admin-auth/login`;

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.message || "Login failed");
  }

  return await response.json();
}

export async function verifyAdminToken(token) {
  const baseUrl = getApiBaseUrl();
  const response = await fetch(`${baseUrl}/admin-auth/verify`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Token verification failed");
  }

  return await response.json();
}

export async function changeAdminPassword(oldPassword, newPassword) {
  return fetchAPI("/admin-auth/change-password", {
    method: "POST",
    body: JSON.stringify({ oldPassword, newPassword }),
  });
}

export async function getAdminProfile(adminId) {
  return fetchAPI(`/admin-auth/profile/${adminId}`);
}
